import { render, staticRenderFns } from "./BorrowerFeeConfiguration.vue?vue&type=template&id=20441a8c&scoped=true"
import script from "./BorrowerFeeConfiguration.vue?vue&type=script&lang=js"
export * from "./BorrowerFeeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./BorrowerFeeConfiguration.vue?vue&type=style&index=0&id=20441a8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20441a8c",
  null
  
)

export default component.exports